import { RoutesEnum } from '~/enums'
export const CONTACT_TYPE = {
  FACEBOOK: 'FACEBOOK',
  YOUTUBE: 'YOUTUBE',
  LIVECHAT: 'LIVECHAT',
}
export const HIDE_ARROW_TIMEOUT = 300
export const SCROLL_THRESHOLD_DESKTOP = 1.2
export const SCROLL_THRESHOLD_MOBILE = 30
export const HEIGHT_HERO_BANNER_DESKTOP = 250
export const HEIGHT_HERO_BANNER_MOBILE = 80
export const MODAL_CONTACTS_MOBILE_ID = 'modalContactsMobile'
export const LIST_SHOW_SCROLL_TO_TOP = [
  RoutesEnum.Home.toString(),
  RoutesEnum.Sports.toString(),
  RoutesEnum.News.toString(),
]
export const LIST_SHOW_SCROLL_TO_TOP_ABSOLUTE_PATH = [
  RoutesEnum.LobbyGame.toString(),
  RoutesEnum.LiveCasino.toString(),
  RoutesEnum.EventDrawingLots.toString(),
]
